import api from '../config/api';
const TOKEN = localStorage.getItem('token');
const header = TOKEN ? {
  'Content-Type': 'application/json',
  'Authorization': 'Bearer ' + TOKEN
} : {'Content-Type': 'application/json'};

const API = new api({headers: header});
const APIUpload = new api({headers: {...header, 'Content-Type': 'multipart/form-data'}});

//AUTH API
const AuthAPI = {
  postLogin: (payload) => API.post('auth/login', payload),
  postForgotPassword: (payload) => API.post('auth/forgot-password', payload),
  postVerifyPassword:(payload) => API.post('/auth/forgot-password/verify', payload),
  getGetMenu: (payload) => API.get('/menu-access', payload),
};

// FORM API
const FormModuleAPI = {
  getModule: () => API.get('form-model'),
  postModule: (payload) => API.post('form-model/create', payload),
  updateModule: (payload, param) => API.put(`form-model/module/${param}`, payload),
  deleteModule: (payload) => API.delete(`form-model/module/${payload}`),
  getSubModule: (payload) => API.get(`form-model/${payload}`),
  postSubModule: (payload, param) => API.post('form-model/submodule', payload, param),
  updateSubModule: (payload, param) => API.put('form-model/submodule', payload, param),
  deleteSubModule: (payload) => API.delete('form-model/submodule', payload),
  postYItem: (payload, param) => API.post('form-model/yItem', payload, param),
  updateYItem: (payload, param) => API.put('form-model/yItem', payload, param),
  deleteYItem: (payload) => API.delete('form-model/yItem', payload),
  postXItem: (payload, param) => API.post('form-model/xItem', payload, param),
  updateXItem: (payload, param) => API.put('form-model/xItem', payload, param),
  deleteXItem: (payload) => API.delete('form-model/xItem', payload)
};

const RoleAccessAPI = {
  getRoleAccess: () => API.get('role-access'),
  getAllRoleAccess: () => API.get('role-access/list'),
  getMenuAccessByRole: (payload) => API.get('role-access/menu-access', payload),
  postAddRoleAccess: (payload) => API.post('role-access/add', payload),
  postAddMenuAccess: (payload) => API.post('role-access/add-menu-access', payload),
  updateRoleAccess: (payload, param) => API.put('role-access/update', payload, param),
  deleteRoleAccess: (payload) => API.delete('role-access/delete', payload)
};

const UserAPI = {
  getUserProfile: (config) => API.get('user/profile', config),
  getUserList: () => API.get('user/list'),
  getUserListByRole: (roleId) => API.get(`user/list-by-role?roleId=${roleId}`),
  getUserDetail: (payload) => API.get(`user/detail?userId=${payload}`),
  deleteUser: (payload) => API.delete(`/user/delete?userId=${payload}`),
  postUser: (payload) => API.post('user/create', payload),
  updateUser: (payload, param) => API.put('user/update', payload, param),
  postConfirmAction: (payload) => API.post('user/verification-password', payload)
};

const ParamAPI = {
  getList: (payload) => API.get('parameter', {params: payload}),
  getAllParamList: (payload) => API.get('parameter-list', {params: payload}),
  getParamDetail: (payload) => API.get(`parameter-detail?paramId=${payload}`),
  postParameter: (payload) => API.post('parameter-create', payload),
  updateParamValue: (payload, param) => API.put(`parameter-update`, payload, param),
};

const MasterDataAPI = {
  //Product
  getProductList: (payload) => API.get(`product-list`, {params: payload}),
  getProductDetail: (id) => API.get(`product-detail?productId=${id}`),
  postProduct: (payload) => API.post(`product-create`, payload),
  updateProduct: (id, payload) => API.put(`product-update?productId=${id}`, payload),
  deleteProduct: (id) => API.put(`product-update?productId=${id}`, {isDelete: true}),
  //Branch
  getBranchList: () => API.get(`branch/list`),
  getBranchDetail: (payload) => API.get(`branch/detail?branchId=${payload}`),
  postBranch: (payload) => API.post(`branch/create`, payload),
  updateBranch: (payload, param) => API.put(`branch/update`, payload, param),
  deleteBranch: (payload) => API.delete(`branch/delete`, payload),
} 

const LoanAPI = {
  //Data Entry
  postDataAccount:(payload) => API.post(`data-account-create`, payload),
  getDataEntryList:() => API.get(`data-entry-list`),
  getDataAccountDetail:(params) => API.get(`data-account-detail`, {params}),
  updateDataAccount:(payload, param) => API.put(`data-account-update`, payload, param),
  deleteDataAccount: (id) => API.put(`data-account-update?accountId=${id}`, {isDelete: true}),
  uploadFileDataEntry:(payload, param) => APIUpload.put(`data-account-upload-file`, payload, param),
  getStagingReview:(params) => API.get(`data-account-staging-review`, {params}),
  updateStagingReview:(payload, param) => API.put('data-account-staging-review-update', payload, param),
  // Data Entry -> Collateral Data
  getCollateralDetail:(params) => API.get(`data-account-collateral-detail`, {params}),
  updateCollateralDetail:(payload, params) => API.put(`data-account-collateral-update`, payload, {params}),
  uploadCollateralFile:(payload, params) => APIUpload.put(`data-account-collateral-file-upload`, payload, params),
  deleteCollateralFile:(payload, params) => APIUpload.put(`data-account-collateral-file-delete`, payload, {params}),
  // Verifikasi Data
  getDataVerificationList:() => API.get(`data-verification-list`),
  // Realization
  getDataRealizationList:() => API.get(`data-realization-list`),
  putExecuteRealization:(payload, param) => API.put(`data-account-execute-realization`, payload, param),
  putExecuteRealizationDisbursement:(payload, param) => API.put(`data-account-execute-realization-disbursement`, payload, param),
  putGenerateDocumentAgreement: (payload, params) => API.put(`data-account-execute-document-agreement`, payload, {params}),
  // Inquiry Data
  getInquiryDataList:(params) => API.get(`data-inquiry`, {params}),
  // Verifikasi Data SLIK
  getDataSlikList:(payload) => API.get(`data-slik-list`, {params: payload}),
  updateSlikStatus:(payload, param) => API.put(`data-account-slik-update`, payload, param),
  // Batch Sumber Dana
  getBatchSourceFundsList:(params) => API.get(`batch-source-funds-list`, {params}),
  getBatchSourceFund:(params) => API.get(`batch-source-funds-detail`, {params}),
  getSourceFundSubmissions:() => API.get(`batch-source-funds-customer-get`),
  setSelectedSourceFundSubmissions:(payload) => API.post(`batch-source-funds-set-customer`, payload),
  postBatchSourceFund: (params) => API.post(`batch-source-funds-create`, params),
  updateBatchSourceFund:(payload, param) => API.put(`batch-source-funds-update`, payload, param),
  getBatchSourceFundDroppingList:(params) => API.get(`batch-source-funds-dropping-list`, {params}),
  updateBatchSourceFundDropping:(payload, params) => API.put(`batch-source-funds-dropping-update`, payload, {params}),
  // Pelunasan
  getDataRepayment:(params) => API.get(`repayment/get-data`, {params}),
  postSubmitRepayment:(payload) => API.post(`repayment/submit`, payload),
  getRepaymentSubmissionList:(params) => API.get(`repayment/get-list-submission`, {params}),
  getRepaymentSubmissionDetail:(params) => API.get(`repayment/get-detail-submission`, {params}),
  putSubmitRepaymentFeedback:(payload, params) => APIUpload.put(`repayment/submit-feedback`, payload),
  // Approval Sumber Dana
  getBatchSourceFundDroppingListApproval:(params) => API.get(`batch-source-funds-dropping-list-approval`, {params}),
  putBatchSourceFundDroppingApprove:(payload, params) => API.put(`batch-source-funds-dropping-approve`, payload, {params}),
}

const CollectionAPI = {
  getDataCollectionList:(params) => API.get(`data-collection-list`, {params}),
  payInstallment:(payload, param) => API.put(`data-collection-pay`, payload, param), 
}

const TellerAPI = {
  getMutation: (params) => API.get('funding/mutation', {params}),
  postTransaction: (payload) => API.post('funding/transaction', payload),
  getDataDisbursementList: () => API.get('customer/list-data-disbursement'),
  putExecuteDisbursement: (payload, params) => API.put('data-account-execute-disbursement/', payload, {params}),
  getInquiryDataFinancingBill: (params) => API.get('customer/inquiry-data-financing-bill', {params}),
  putPaymentBill: (payload, params) => API.put('data-account-payment-bill', payload, {params}),
  //transactionCollective
  getTransactionCollective: (params) => API.get('funding/transaction-collective-list', {params}),
  postTransactionCollective: (payload) => API.post('funding/transaction-collective-create', payload),
  getTransactionCollectiveDetail: (params) => API.get('funding/transaction-collective-detail-get', {params}),
  addTransactionCollectiveItem: (payload) => API.put('funding/transaction-collective-detail-add', payload, {}),
  deleteTransactionCollectiveItem: (payload) => API.delete('funding/transaction-collective-detail-delete', {data: payload}),
  executeTransactionCollective: (payload) => API.put('funding/transaction-collective-execute', payload, {}),
  //failedTransaction
  getFailedTransactionList: (params) => API.get('funding/transaction-failed', {params}),
  //Pelunasan
  putApproveRepaymentTeller: (payload, params) => API.put(`repayment/approved-teller`, payload, {params}),
}

const AssetsAPI = {
  getAssetsList: (params) => API.get(`assets/list`, {params}),
  getAssetDetail: (params) => API.get(`assets/detail`, {params}),
  postAsset: (payload) => API.post(`assets/create`, payload),
  updateAsset: (payload, param) => API.put(`assets/update`, payload, param),
  deleteAsset: (payload) => API.delete(`assets/delete`, payload),
}

const CustomerAPI = {
  getInquiryDataCIF: (params) => API.get('customer/inquiry-data', {params}),
  getCustomerList: (params) => API.get('customer', {params}),
  postCustomer: (payload) => API.post('customer/register', payload),
  getCustomerDetail: (params) => API.get('customer/detail', {params}),
  updateCustomer: (payload, param) => API.put('customer/update', payload, param),
  uploadFileCustomer:(payload, param) => APIUpload.put(`customer/document-upload-file`, payload, param),
  getCustomerByAccountNumber:(params) => API.get('customer/inquiry-data-by-savings', {params}),
}

const AbsensiAPI = {
  postAttendance:(payload) => API.post(`attendance`, payload),
  postGetDataAttendance:(payload) => API.post(`getattendance`, payload),
  getAttendanceList:(params) => API.get(`getattendancelist`, {params}),
  getAttendanceDetail:(params) => API.get(`getattendancedetail`, {params}),
  postRetakeImageAttendance:(payload) => API.post(`attendance/retake-image-attendance`, payload),
  getAttendanceUserSummary:(params) => API.get(`get-attendance-user-detail`, {params}),
};

const DocumentAPI = {
  getDocument:(params) => API.get(`document-data`, {params, responseType: "blob"}),
  getDocumentRepayment:(params) => API.get(`repayment/get-file`, {params, responseType: "blob"}),
};

const AccountingAPI = {
  getListBukuBesar:(payload) => API.get(`accounting-general-ledger`, {params: payload}),
  getListJurnalUmum:(payload) => API.get(`accounting-general-journal`, {params: payload}),
  getListingJournal:(params) => API.get(`accounting-listing-journal`, {params}),
  getJournalTransactionList:(params) => API.get('journal-transaction/list',{params}),
  getJournalTransactionDetail:(params) => API.get('journal-transaction/detail',{params}),
  postJournalTransaction:(payload) => API.post('journal-transaction/create', payload),
  getJournalTransactionSummary:(params) => API.get(`accounting-journal-transaction-summary`, {params}),
  getInsuranceList:(params) => API.get(`insurance/list`, {params}),
  getInsuranceDetail:(params) => API.get(`insurance/detail`, {params}),
  putPayInsurance:(payload) => API.put(`insurance/payment`, payload),
  //Rekonsiliasi
  getRAKTransactionDay:(params) => API.get(`accounting-rak-transaction-day`, {params}),
  getRAKTransactionMonth:(params) => API.get(`accounting-rak-transaction-month`, {params}),
  //NERACA
  getBalanceSheetBranch: (params) => API.get(`accounting/balance-sheet/branch`, {params}),
  getResidualIncomeBranch: (params) => API.get(`accounting/residual-income/branch`, {params}),
}

const CoAAPI= {
  //Coa
  getCoaList: (params) => API.get('coa/list', {params}),
  getCoaListForTransaction: (params) => API.get(`coa/list-for-transaction`, {params}),
  getCoaDetail: (payload) => API.get(`coa/detail`, payload),
  postCoa: (payload) => API.post('coa/create', payload),
  updateCoa: (payload, param) => API.put('coa/update', payload, param),
  deleteCoa: (payload) => API.delete(`/coa/delete`, payload),
  getParameterList: (payload) => API.get(`/parameter-list`, payload),
  postSetInitialBalance: (payload) => API.post('coa/set-initial-balance', payload),
}

const SavingAPI = {
  postCreateSaving: (payload) => API.post(`savings/create`, payload),
  getSavingDetail: (params) => API.get(`savings/detail`, {params}),
  putUpdateSaving: (payload, params) => API.put(`savings/update`, payload, {params}),
}

const JournalSetupAPI = {
  postJournalSetupLoan: (payload) => API.post(`journal-setup/loan/create`, payload),
  getJournalSetupLoanList: (params) => API.get(`journal-setup/loan/list`, {params}),
  getJournalSetupLoanDetail: (params) => API.get(`journal-setup/loan/detail`, {params}),
  updateJournalSetupLoan: (payload, params) => API.put(`journal-setup/loan/update`, payload, {params}),
  putAddJournalModule: (payload, params) => API.put(`journal-setup/loan/add-to-module`, payload, {params}),
  putUpdateJournalModule: (payload, params) => API.put(`journal-setup/loan/edit-to-module`, payload, {params}),
  deleteJournalModule: (params) => API.delete(`journal-setup/loan/delete-to-module`, {params}),
  putAddJournalParam: (payload, params) => API.put(`journal-setup/loan/add-parameter`, payload, {params}),
  putUpdateJournalParam: (payload, params) => API.put(`journal-setup/loan/edit-parameter`, payload, {params}),
  deleteJournalParam: (params) => API.delete(`journal-setup/loan/delete-parameter`, {params}),
  //document
  putAddJournalDoc: (payload, params) => API.put(`journal-setup/document/add`, payload, {params}),
  putUploadJournalDoc: (payload, param) => APIUpload.put(`journal-setup/document/upload`, payload, param),
  deleteJournalDoc: (params) => API.delete(`journal-setup/document/delete`, {params}),
}

const Services = {
  ...AuthAPI,
  ...FormModuleAPI,
  ...RoleAccessAPI,
  ...UserAPI,
  ...ParamAPI,
  ...MasterDataAPI,
  ...LoanAPI,
  ...CollectionAPI,
  ...TellerAPI,
  ...AssetsAPI,
  ...CustomerAPI,
  ...DocumentAPI,
  ...AbsensiAPI,
  ...AccountingAPI,
  ...CoAAPI,
  ...SavingAPI,
  ...JournalSetupAPI,
};

export default Services;
